import { createStore } from 'redux';
import { storageGetItem } from '@/utils/storage';
export function createAppStore(rootReducer) {
  return createStore(rootReducer);
}
export function getStoredUserInfo() {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return storageGetItem('user');
  } catch {
    return null;
  }
}
export function normalizeUserInfo(value) {
  return {
    ...value,
    permissions: value?.permissions ?? {}
  };
}
function parseEnumValueByType(value, type) {
  const nextType = String(type ?? '').trim();
  if (nextType === 'Integer') {
    const parsedValue = Number.parseInt(String(value ?? ''), 10);
    return Number.isNaN(parsedValue) ? value : parsedValue;
  }
  if (nextType === 'Float') {
    const parsedValue = Number.parseFloat(String(value ?? ''));
    return Number.isNaN(parsedValue) ? value : parsedValue;
  }
  if (nextType === 'Boolean') {
    if (typeof value === 'boolean') {
      return value;
    }
    const normalizedValue = String(value ?? '').trim().toLowerCase();
    if (['true', '1', 'yes', 'y'].includes(normalizedValue)) {
      return true;
    }
    if (['false', '0', 'no', 'n'].includes(normalizedValue)) {
      return false;
    }
  }
  return value;
}
function normalizeEnumItemData(item) {
  const nextData = item.data ? {
    ...item.data,
    value: parseEnumValueByType(item.data.value, item.data.type)
  } : undefined;
  return {
    ...item,
    value: parseEnumValueByType(item.value, item.data?.type),
    data: nextData,
    children: item.children?.map(normalizeEnumItemData)
  };
}
export function loop(children) {
  if (!Array.isArray(children)) {
    return [];
  }
  return children.map(item => normalizeEnumItemData(item));
}
export function formatEnum(data) {
  console.log('data', data);
  const enumListMap = {};
  const enumObjectMap = {};
  const enumHtmlMap = {};
  const enumObjectData = {};
  const enumIdMap = {};
  const enumNameMap = {};
  data?.forEach(item => {
    if (!item.code) {
      return;
    }
    const obj = {};
    const html = {};
    const dataMap = {};
    enumIdMap[item.code] = item.uid ?? '';
    enumNameMap[item.code] = item.name ?? '';
    enumListMap[item.code] = loop(item.children);
    item.children?.forEach(it => {
      const normalizedItem = normalizeEnumItemData(it);
      const value = String(normalizedItem.value ?? '');
      if (!value) {
        return;
      }
      obj[value] = String(normalizedItem.text ?? '');
      html[value] = String(normalizedItem.data?.data?.html ?? '');
      dataMap[value] = normalizedItem.data ?? {};
    });
    enumObjectMap[item.code] = obj;
    enumHtmlMap[item.code] = html;
    enumObjectData[item.code] = dataMap;
  });
  return {
    enumListMap,
    enumObjectMap,
    enumHtmlMap,
    enumObjectData,
    enumIdMap,
    enumNameMap
  };
}